var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lsc5asxgia)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#zcvs0stlqb)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1.733c-6.432 0-11.646 5.214-11.646 11.646s5.214 11.646 11.645 11.646c6.432 0 11.646-5.214 11.646-11.646S19.431 1.733 13 1.733z",
    fill: "url(#d1j5kqs58c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.465 2.097A.813.813 0 0 0 5.45.828L2.742 2.995a.812.812 0 0 0 1.015 1.269l2.708-2.167z",
    fill: "url(#pjbclq6chd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.549.828a.812.812 0 0 0-1.016 1.269l2.709 2.167a.812.812 0 1 0 1.015-1.27L20.549.829z",
    fill: "url(#h2d3qv0ube)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.224 4.449.39-.312-.39.312a1.313 1.313 0 0 0 1.845.205l2.709-2.167a1.312 1.312 0 1 0-1.64-2.05l.312.391-.312-.39-2.709 2.166a1.312 1.312 0 0 0-.205 1.845zM13 1.233C6.291 1.233.854 6.671.854 13.38c0 6.708 5.437 12.146 12.145 12.146 6.708 0 12.146-5.438 12.146-12.146 0-6.708-5.438-12.146-12.146-12.146zm7.862-.795a1.312 1.312 0 0 0-1.845.205v0a1.313 1.313 0 0 0 .205 1.844l2.708 2.167a1.312 1.312 0 0 0 1.64-2.05L20.861.438z",
    stroke: "url(#b4d5xfun0f)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ewhyouzwkg)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.811 9.046a.813.813 0 0 0-1.625 0v4.556c0 .346-.132.678-.369.93l-1.576 1.671a.812.812 0 1 0 1.182 1.115L13 15.646a2.98 2.98 0 0 0 .811-2.044V9.046z",
    fill: "#001F55"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d1j5kqs58c",
    x1: 12.999,
    y1: 0.65,
    x2: 12.999,
    y2: 25.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBEDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pjbclq6chd",
    x1: 12.999,
    y1: 0.65,
    x2: 12.999,
    y2: 25.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBEDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h2d3qv0ube",
    x1: 12.999,
    y1: 0.65,
    x2: 12.999,
    y2: 25.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBEDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b4d5xfun0f",
    x1: 1.354,
    y1: 0.65,
    x2: 25.715,
    y2: 23.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "zcvs0stlqb",
    x: -23.646,
    y: -24.35,
    width: 73.291,
    height: 74.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_401_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_401_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ewhyouzwkg",
    x: 7.02,
    y: 5.233,
    width: 19.791,
    height: 25.34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_401_1863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_401_1863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lsc5asxgia"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v26H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeCircle);
export default __webpack_public_path__ + "static/media/TimeCircle.f892b8cc7e8e8886afaf39ea6cbe5f08.svg";
export { ForwardRef as ReactComponent };